import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingController, ModalController, ToastController} from '@ionic/angular';
import { Chart, registerables } from 'chart.js';
import {DefaultComponent} from "../../shared/components/default.component";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {FinanceService} from "./finance.service";
import {delay, takeUntil} from "rxjs/operators";
import {ElementOptions, ElementsOptions, StripeCardComponent, StripeService} from "@nomadreservations/ngx-stripe";
import {OrdersService} from "../../public/order/orders.service";
import {PaymentIntentService} from "../../public/order/paymentIntent.service";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {PaymentWalletIntentService} from "./paymentWalletIntent.service";
import {SharedUserService} from "../../shared/_services/shareduser.service";
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-finance',
  templateUrl: './finance.html',
  styleUrls: ['./finance.scss'],
})
export class Finance extends DefaultComponent implements OnInit {
  selectedSegment: string = 'overview';
  transaction: any = {};
  isKey: boolean = false;
  orderForm!: UntypedFormGroup;
  submitted = false;
  error: any = {};
  showErrors = false;
  hide = true;


  public cardOptions: ElementOptions = {
    hidePostalCode: true,
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#fff',
        lineHeight: '70px',
        fontWeight: 300,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#ffffff'
        },

      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    },
  };

  elementsOptions: ElementsOptions = {
    locale: 'en',

  };
  user: any = {};
  private key: any;
  private iserror: boolean;
  private activ: boolean;
  payment: any;
  private paymentResult: string;
  paymentStatus: boolean = false;
  price: any;
  energy_rate: any;
  errorMessage: any;
  intentStatus: boolean = false;
  isLoading = false;

  stripeKey : string = environment.stripeKey;
  @ViewChild(StripeCardComponent) card: StripeCardComponent;

  constructor(
      private formBuilder: UntypedFormBuilder,
      private modelCtrl: ModalController,
      router: Router,
      activatedRoute: ActivatedRoute,
      sharedRoutesService: SharedRoutesService,
      private runningTransactionService: FinanceService,
      private ordersService: OrdersService,
      private paymentWalletIntentService: PaymentWalletIntentService,
      private stripeService: StripeService,
      private loadingCtrl: LoadingController,
      private sharedUserService: SharedUserService,
      toastController: ToastController





  ) {
    super(router, activatedRoute, sharedRoutesService,toastController);
    Chart.register(...registerables);

  }

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      amount: ['', Validators.required],
      // address: ['', Validators.required],
    });
   this.getUser();

  }


  getUser() {
    this.sharedUserService.getMe()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
            (data) => {
              this.user = data;
            });
  }


  async showSuccessAcction() {
  const toast = await this.toastController.create({
    message:  'Payment was successful.',
    duration: 1000,
    color: 'dark'
  });
  toast.present();

  window.location.reload();

}

  createPayment() {
    this.isLoading = true;

    this.loadingCtrl.create({
      keyboardClose: true,
      message: 'Processing payment...'
    }).then(loadingEl => {
      loadingEl.present();

      const queryParams = {
        data: this.orderForm.value,
        calculated_price: this.price,
        key: this.key,
        cart_id: 1
      };

      this.paymentWalletIntentService.create(queryParams).subscribe(result => {
        const clientSecret = (result as any)?.client_secret;

        if (clientSecret) {
          this.stripeService
              // @ts-ignore
              .handleCardPayment(clientSecret, this.card.getCard())
              .subscribe(data => {
                console.log('data_status', data);

                // ✅ FIRST: Handle errors
                if (data?.error) {
                  const message = data.error.message || 'Payment failed';

                  this.paymentResult = message;
                  this.paymentStatus = false;
                  this.intentStatus = false;
                  this.errorMessage = message;
                  this.iserror = true;
                  this.showErrors = true;

                  loadingEl.dismiss();

                  this.toastController.create({
                    message,
                    duration: 3000,
                    color: 'danger'
                  }).then(toast => toast.present());

                  console.error('Stripe error:', data);
                  return; // Stop further processing
                }

                // ✅ THEN: Proceed if paymentIntent exists
                if (data?.paymentIntent?.id) {
                  const paymentParams = {
                    id: data.paymentIntent.id,
                    key: this.key,
                  };

                  this.paymentWalletIntentService.validatePayment(paymentParams).subscribe(result => {
                    this.paymentResult = 'Success';
                    this.paymentStatus = true;
                    this.intentStatus = true;
                    console.log('success', result);
                    loadingEl.dismiss();
                    this.showSuccessAcction();
                  }, () => {
                    this.paymentResult = 'Validation failed';
                    this.paymentStatus = false;
                    this.intentStatus = false;
                    loadingEl.dismiss();
                  });
                } else {
                  this.paymentResult = 'Unknown payment response';
                  this.paymentStatus = false;
                  this.intentStatus = false;
                  this.errorMessage = this.paymentResult;
                  this.iserror = true;
                  this.showErrors = true;
                  loadingEl.dismiss();
                }
              });

        } else {
          // client_secret missing
          this.paymentResult = 'Error creating payment intent';
          this.intentStatus = false;
          this.energy_rate = null;
          this.errorMessage = this.paymentResult;
          this.iserror = true;
          this.showErrors = true;
          loadingEl.dismiss();

          this.toastController.create({
            message: this.paymentResult,
            duration: 3000,
            color: 'danger'
          }).then(toast => toast.present());

          console.error('Intent error:', result);
        }
      }, err => {
        // API/network error
        this.paymentResult = 'Unable to create payment intent';
        this.intentStatus = false;
        this.errorMessage = this.paymentResult;
        this.iserror = true;
        this.showErrors = true;
        loadingEl.dismiss();

        this.toastController.create({
          message: this.paymentResult,
          duration: 3000,
          color: 'danger'
        }).then(toast => toast.present());

        console.error('Request failed:', err);
      });
    });
  }


  change(event) {

    if (event.complete == true) {
      this.iserror = false;
      this.showErrors = false;
      this.activ = true;
    } else {
      console.log('err', event);
      this.error = event.card.error;
      this.errorMessage = this.error.message;
      console.log('error', this.error)
      this.iserror = true;
      this.showErrors = true;
    }

  }

  round(number, precision) {
    var factor = Math.pow(10, precision);
    var tempNumber = number * factor;
    var roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
  };
}
